// src/components/customers/CustomerCreationModal.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useCustomers } from '../../hooks/useCustomers';
import CustomerForm from '../ui/forms/CustomerForm/CustomerForm';

const CustomerCreationModal = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const { createCustomer, creatingCustomer, isConnected } = useCustomers();
  const [submitError, setSubmitError] = useState(null);

  // Canonical: Saving flag watcher — close modal on server confirmation
  const prevCreatingCustomer = useRef(false);
  useEffect(() => {
    if (prevCreatingCustomer.current && !creatingCustomer) {
      if (isOpen) {
        onClose();
      }
    }
    prevCreatingCustomer.current = creatingCustomer;
  }, [creatingCustomer, isOpen, onClose]);

  // Clear error when modal opens
  useEffect(() => {
    if (isOpen) {
      setSubmitError(null);
    }
  }, [isOpen]);

  // Handle customer creation — fire-and-forget
  const handleCreateCustomer = (customerData) => {
    if (!isConnected) {
      setSubmitError('Not connected to server. Please check your connection.');
      return;
    }

    setSubmitError(null);
    createCustomer(customerData);
    // Modal close handled by creatingCustomer flag watcher
  };

  // Handle modal close
  const handleClose = () => {
    if (!creatingCustomer) {
      setSubmitError(null);
      onClose();
    }
  };

  return (
    <CustomerForm
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={handleCreateCustomer}
      loading={creatingCustomer}
      error={submitError}
    />
  );
};

export default CustomerCreationModal;
